import React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const THUMB_SIZE = 18;

const DesignSwitch = styled(Switch)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: 40,
  height: 24,
  padding: 0,
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    padding: 3,
    '&.Mui-checked': {
      transform: 'translateX(-4px)',
      '& + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.shade?.[700] : theme.palette.shade?.[200],
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-track': {
    width: 30,
    height: 14,
    borderRadius: 12,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.shade?.[700] : theme.palette.shade?.[200],
  },
}));

// Switch's `icon`/`checkedIcon` props replace the default thumb node entirely
// (losing its built-in white circle + shadow), so the ball has to be rebuilt
// here rather than styled via the `.MuiSwitch-thumb` class.
const DesignSwitchThumb = styled('span')(({ theme }) => ({
  width: THUMB_SIZE,
  height: THUMB_SIZE,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[1],
}));

export const DesignSwitchCheckIcon = <DesignSwitchThumb />;

export default DesignSwitch;
